import suscripcionesFormModel from './suscripcionesFormModel';

const {
  formField: {
    customerId,
    planId,
    startsAt,
    expiresAt,
    renewalType,
    monthlyCredits,
    nextRenewalAt,
    statusSuscription,
  },
} = suscripcionesFormModel;

export default {
  [customerId.name]: null,
  [planId.name]: '',
  [startsAt.name]: null,
  [expiresAt.name]: null,
  [renewalType.name]: '',
  [monthlyCredits.name]: '',
  [nextRenewalAt.name]: null,
  [statusSuscription.name]: '',
};
